import * as i0 from '@angular/core';
import { Component, HostBinding, Input, NgModule } from '@angular/core';

class SeFeLinkComponent {
    constructor() {
        this.baseClass = true;
        this.emphasis = 'high';
    }
    get highClass() { return this.emphasis === '' || this.emphasis === 'high'; }
    get tabindex() {
        return this._tabindex || '0';
    }
    set tabindex(tabindex) {
        this._tabindex = tabindex;
    }
}
SeFeLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeLinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeLinkComponent, selector: "[seFeLink]", inputs: { emphasis: ["seFeLink", "emphasis"], tabindex: "tabindex" }, host: { properties: { "class.se-fe-link": "this.baseClass", "class.se-fe-link--high": "this.highClass", "attr.tabindex": "this.tabindex" } }, ngImport: i0, template: '<span class="se-fe-link__wrapper"><ng-content></ng-content></span>', isInline: true, styles: [":host{appearance:none!important;background:none;border:0;box-sizing:border-box;color:inherit;cursor:pointer;display:inline;font:inherit;line-height:inherit;margin:0;outline:0;padding:0;white-space:normal!important;word-break:break-word;text-align:left;text-decoration:none;color:var(--se-link);text-decoration:underline;-webkit-text-decoration-skip:ink;text-decoration-skip-ink:auto;-webkit-text-decoration-color:transparent;text-decoration-color:transparent;text-decoration-thickness:1px;text-underline-offset:3px;vertical-align:baseline}:host.se-fe-link--high{-webkit-text-decoration-color:inherit;text-decoration-color:inherit}:host:hover{color:color-mix(in srgb,var(--se-text) var(--se-hover-mix),var(--se-link))}:host:active,:host[aria-pressed=true],:host:has([aria-pressed=true]){color:color-mix(in srgb,var(--se-text) var(--se-pressed-mix),var(--se-link))}:host:focus-visible,:host:has(*:focus-visible){box-shadow:var(--se-focus-shadow);border-radius:4px;z-index:var(--se-z-focus)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeLinkComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[seFeLink]',
                    template: '<span class="se-fe-link__wrapper"><ng-content></ng-content></span>',
                    styleUrls: ['./se-fe-link.component.scss'],
                }]
        }], propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-link']
            }], highClass: [{
                type: HostBinding,
                args: ['class.se-fe-link--high']
            }], emphasis: [{
                type: Input,
                args: ['seFeLink']
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }, {
                type: Input,
                args: ['tabindex']
            }] } });

class SeFeLinkModule {
}
SeFeLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeLinkModule, declarations: [SeFeLinkComponent], exports: [SeFeLinkComponent] });
SeFeLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeLinkModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeLinkComponent],
                    exports: [SeFeLinkComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeLinkComponent, SeFeLinkModule };
